export default {
  'card-sm': '4px 4px 8px rgba(0, 0, 0, 0.2)',
  card: '12px 12px 24px rgba(0, 0, 0, 0.2)',
  'card-md': '18px 18px 36px rgba(0, 0, 0, 0.2)',
  'card-lg': '30px 30px 60px rgba(0, 0, 0, 0.2)',
  button: '8px 8px 14px rgba(0, 0, 0, 0.2)',
  'button-sm': '2px 2px 8px rgba(0, 0, 0, 0.2)',
  'button-xs': '1px 1px 4px rgba(0, 0, 0, 0.2)',
  'text-sm': '1px 1px 4px rgba(0, 0, 0, 0.2)',
  text: '2px 2px 8px rgba(0, 0, 0, 0.2)',
  'text-lg': '3px 3px 12px rgba(0, 0, 0, 0.2)',
  stickyHeader: '20px 20px 40px rgba(0, 0, 0, 0.1)',
  avatar: '0px 1px 4px rgba(0, 0, 0, 0.2)',
};
